import React, { useState } from "react";
import {
  Nav,
  Container,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
} from "reactstrap";
import NewLicense from "./NewLicense";
export default function Previewplan({ title }) {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <div>
      <Container>
        <div className="page-title">
          <h4>{title}</h4>
        </div>
        <div className="new-license">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={{ active: activeTab === "1" }}
                onClick={() => {
                  toggle("1");
                }}
              >
                Application Form
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={{ active: activeTab === "2" }}
                onClick={() => {
                  toggle("2");
                }}
              >
                Additional Document
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent className="mt-5" activeTab={activeTab}>
            <TabPane tabId="1">
              <NewLicense />
            </TabPane>
            <TabPane tabId="2"></TabPane>
          </TabContent>
        </div>
      </Container>
    </div>
  );
}
